import { registerSW } from 'virtual:pwa-register'

import { pwaUpdate } from '@/app/pwa/update'

/** How often an open tab asks the server for a newer version. */
const CHECK_EVERY_MS = 60 * 60 * 1000

/**
 * Service-worker registration.
 *
 * Updates are explicit: the user is prompted rather than having assets swapped
 * mid-session, so a newer frontend is never mixed with incompatible cached assets
 * (SRS NFR-PWA-02, NFR-PWA-06). The prompt (UpdatePrompt) reloads onto the new version;
 * nobody needs to clear site data - which would also wipe the attendance device key.
 */
export function registerServiceWorker(): void {
  if (import.meta.env.DEV) return

  const update = registerSW({
    immediate: false,
    onNeedRefresh() {
      pwaUpdate.ready = true
    },
    onRegisteredSW(_url, registration) {
      // a tab left open all day still learns about a deploy
      if (registration) setInterval(() => void registration.update(), CHECK_EVERY_MS)
    },
  })
  pwaUpdate.apply = () => update(true)
}
